<template>
  <b-modal
    title="Application Feedback"
    v-model="showModal"
    hide-footer
    centered
  >
    <div class="fb">
      <div v-if="needsSignature" class="fb-sign">
        <p class="fb-sign__note">
          <AppIcon name="alert" :size="18" />
          Your signature is required before you can submit feedback.
        </p>
        <ReviewSignature />
      </div>

      <label class="ecu-m-label">Choose an action</label>

      <DecisionCards
        v-model="selectStatusPro"
        :options="allowedStatusOptions(currentAppStatus)"
      />

      <p v-if="feedbackError" class="ecu-m-alert ecu-m-alert--error fb-gap">
        <AppIcon name="alert" :size="18" /> {{ feedbackError }}
      </p>

      <template v-if="selectStatusPro === 'incomplete' || selectStatusPro === 'rejected'">
        <div class="fb-group" v-for="item in itemsss" :key="item">
          <div v-if="selectStatusPro !== 'rejected'" class="ecu-m-field">
            <label class="ecu-m-label">Application Section</label>
            <EcuSelect
              v-model="incompleteAppStatus"
              :options="sectionChoices"
              placeholder="Please Select"
              aria-label="Application section"
            />
          </div>
          <div class="ecu-m-field" :class="{ 'fb-gap': selectStatusPro !== 'rejected' }">
            <label class="ecu-m-label">Comment</label>
            <textarea
              class="ecu-m-input ecu-m-textarea"
              rows="3"
              placeholder="Comment..."
              v-model="incompleteAppComment"
            ></textarea>
          </div>
        </div>

        <div class="fb-add">
          <button type="button" class="fb-add__btn" @click="duplicateItem">
            + Add More Bug
          </button>
        </div>
      </template>

      <div class="ecu-m-actions">
        <button
          type="button"
          class="ecu-m-btn ecu-m-btn--ghost"
          @click="showModal = false"
        >
          Cancel
        </button>
        <button
          type="button"
          class="ecu-m-btn"
          :disabled="selectStatusPro === 'select' || submitting === true || needsSignature"
          @click="submitFeedback"
        >
          <span v-if="submitting === true">Submitting...</span>
          <span v-else>Submit</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { bridge } from "../formBridge";
import AppIcon from "@/components/shared/AppIcon.vue";
import EcuSelect from "@/components/shared/EcuSelect.vue";
import DecisionCards from "@/components/shared/DecisionCards.vue";
import ReviewSignature from "./ReviewSignature.vue";

export default {
  name: "ReviewFeedbackModal",
  components: { AppIcon, EcuSelect, DecisionCards, ReviewSignature },
  mixins: [
    bridge({
      state: [
        "submitting",
        "incompleteAppStatus",
        "incompleteAppComment",
        "showModal",
        "selectStatusPro",
        "currentAppStatus",
        "feedbackError",
        "itemsss",
      ],
      readonly: ["sectionOptions", "needsSignature"],
      methods: ["submitFeedback", "duplicateItem", "allowedStatusOptions"],
    }),
  ],
  computed: {
    sectionChoices() {
      return (this.sectionOptions || []).map((s) => ({ value: s.value, label: s.label }));
    },
  },
};
</script>

<style scoped>
.fb-sign {
  margin-bottom: 18px;
  padding: 14px 16px;
  border: 1.5px solid #f8cfae;
  border-radius: 14px;
  background: #fff8f2;
}
.fb-sign__note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 13.5px;
  font-weight: 600;
  color: #b43d00;
}
.fb-gap {
  margin-top: 16px;
}
.fb-group {
  margin-top: 18px;
  padding: 16px;
  border: 1px solid #eceef5;
  border-radius: 14px;
  background: #fbfcff;
}
.fb-add {
  display: flex;
  justify-content: center;
  margin-top: 14px;
}
.fb-add__btn {
  height: 36px;
  padding: 0 16px;
  border: 1.5px solid #f8cfae;
  border-radius: 10px;
  background: #fff;
  color: #e84d00;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease;
}
.fb-add__btn:hover {
  background: #fff1e6;
}
@media (prefers-reduced-motion: reduce) {
  .fb-add__btn { transition: none; }
}
</style>